__turbopack_context__.v({
  "content": "style-module-scss-module__ozZokW__content",
  "memberDescription": "style-module-scss-module__ozZokW__memberDescription",
  "memberName": "style-module-scss-module__ozZokW__memberName",
  "section": "style-module-scss-module__ozZokW__section",
  "sectionNavButtons": "style-module-scss-module__ozZokW__sectionNavButtons",
  "slide": "style-module-scss-module__ozZokW__slide",
  "slideImage": "style-module-scss-module__ozZokW__slideImage",
  "sliderWrap": "style-module-scss-module__ozZokW__sliderWrap",
  "title": "style-module-scss-module__ozZokW__title",
  "track": "style-module-scss-module__ozZokW__track",
  "viewport": "style-module-scss-module__ozZokW__viewport",
});
